<template>
  <div class="smokeAlarmAuto">
    <div class="smoke-content">
      <div class="hand-h1">报警信息</div>
      <div class="hand-info">
        <div class="hand-text">
          <p>
            <i class="el-icon-time"></i>
            <span class="piTopText">{{ alarmInfo.alarmSingleDO.alarmTime }}</span>
          </p>
          <p>
            <i class="el-icon-location-outline"></i>
            <span class="piTopText">{{ alarmInfo.smokeEquipment.address }}</span>
          </p>
        </div>
        <div class="hand-bot">
          <div v-if=" (alarmInfo.smokeEquipment.equipmnetName || alarmInfo.smokeEquipment.phone)">
            <div class="hand-bot-text">
              <i class="el-icon-s-custom"></i>
              {{ alarmInfo.smokeEquipment.equipmnetName }} | {{ alarmInfo.smokeEquipment.phone }}
              <el-button type="success" @click="callPhone(alarmInfo.smokeEquipment.phone)" size="mini">立即呼叫</el-button>
            </div>
            <div class="hand-bot-text" v-if="alarmInfo.smokeEquipment.equipmnetNametwo != null">
              <i class="el-icon-s-custom"></i>
              {{ alarmInfo.smokeEquipment.equipmnetNametwo }} | {{ alarmInfo.smokeEquipment.phonetwo }}
              <el-button type="success" @click="callPhone(alarmInfo.smokeEquipment.phonetwo)" size="mini">立即呼叫</el-button>
            </div>
            <div class="hand-bot-text">
              <i class="el-icon-s-custom"></i>
              {{ alarmInfo.smokeEquipment.urgencyName }} | {{ alarmInfo.smokeEquipment.urgencyPhone }}
              <el-button type="success" @click="callPhone(alarmInfo.smokeEquipment.urgencyPhone)" size="mini">立即呼叫
              </el-button>
            </div>
          </div>
          <span v-else style="font-size:16px;padding-left: 10px;color: #000;"> 暂无紧急联系人</span>
        </div>
      </div>
    </div>
    <div class="hand-footer-btn">
      <el-button type="primary" @click="falseAlarm">设备误报</el-button>
      <el-button type="primary" @click="dispathOrder">出警派单</el-button>
    </div>
    <div>
      <!-- 第二步调度派单 -->
      <el-dialog
        :visible.sync="dispathOrderDialog"
        :title="q.smokeName"
        
        width="1200px"
        class="dispathOrderBox fire_margin warter_headerClose_color"
        style="margin-top:-8vh;"
        append-to-body
        center
        :close-on-click-modal="false">
        <firePink :alarmId="alarmId" ref="firePink" @closePathOrder="closePathOrder"></firePink>
      </el-dialog>
      <!-- 第三步火场文书 -->
      <el-dialog
        :visible.sync="fireDocuDialog"
        :close-on-click-modal="false"
        width="939px"
        class="fireDoc"
        append-to-body
        :title="q.smokeName"
        center>
        <fireBook
          ref="fireBook"
          :selectRow="selectRow"
          @closeSmokeAlarm="closeSmokeAlarm"
          @closeFireProbe="closeFireProbe"

        ></fireBook>
      </el-dialog>
    </div>
    <!-- 关闭烟感 -->
    <el-dialog
      :title="q.smokeName"
      class="endNoticeDialog"
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
      center>
      <!-- <el-image :src="require('@/assets/img/close.png')"></el-image> -->
      <div class="tip">
        <div class="tip" v-if="q.smokeName == '烟感报警调度派单'" style="color:rgb(0 0 0);font-size:16px; padding-bottom: 10px;">第一步:&nbsp;暂时关闭烟感报警</div>
        <div class="tip" v-else style="color:rgb(0 0 0);font-size:16px; padding-bottom: 10px;">第一步:&nbsp;暂时关闭水压报警</div>
        <el-time-select
          v-model="forbiddentime"
          :picker-options="{
            start:'00:00',
            step: '00:01',
            end: '23:59',
            minTime:startTime
          }"
          placeholder="请选择截止时间">
        </el-time-select>
      </div>
      <div class="tip" style="color:rgb(0 0 0);font-size:16px; padding: 10px 0px;">第二步:&nbsp;误报原因</div>
      <div>
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" v-model="falseContent"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFalseContent">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import fireBook from "@/pages/fireBook/fireBook";
import gaodemap from "@/pages/gaodemap/gaodemap";
import firePink from "@/pages/fireBook/firePink";

export default {
  props: {
    alarmId: {
      default: ''
    },
    q: {
      type: Object
    }
  },
  components: {
    fireBook,
    gaodemap,
    firePink,
  },
  data() {
    return {
      forbiddentime: '',
      handleTitle:'',
      dispathOrderDialog: false,
      fireDocuDialog: false,
      activeName: "first",
      cjPersons: [],
      alarmInfo: {},
      selectCjPersons: [],
      selectEqus: [],
      dialogVisible: false,
      falseContent: "",
      spanIndex: [],
      timelines: [],
      selectRow: {id: this.alarmId},
      form: {msg: ""},
      fileList: [],
      canOper: this.$store.state.canOper,
      fileFormData: {},
      tabsStretch: true,
      isShow: true,
      equs: [],
      selectEquip: true,
      startTime: '',
      smokeName: ''
    };
  },
  created() {
    let _this = this;
    _this.handleSearch();
  },
  mounted() {
    let _this = this;
    _this.fileFormData = new FormData();
    _this.bus.$on('closeDialog', function () {
      _this.dispathOrderDialog = false;
    })
  },
  methods: {
    closeSmokeAlarm() {
      let _this = this;
      _this.$emit("closeSmokeAlarm");
    },
    handleSearch() {
      let _this = this;
      var success = function (resp) {
        _this.cjPersons = [];
        _this.alarmInfo = [];
        _this.cjPersons = resp.userDOList;
        _this.alarmInfo = resp
        resp.equipment.forEach(function (item) {
          item.num = 0;
          _this.equs.push(item);
        });
        _this.selectRow.queryFireBook = resp;
      };
      _this.http.get(
        "/webapi/writ/isMisdeclaration/" + _this.alarmId,
        {},
        success
      );
    },
    queryFireDoucment() {
      //查询火场文书内容
      let _this = this;
      let success = function (resp) {
        _this.timelines = resp.data;
      };
      _this.http.get(
        "/webapi/writ/taskReport/" + _this.selectRow.id,
        {},
        success
      );
    },
    queryFireBook() {
      //查询火场文书
      let _this = this;
      var success = function (resp) {
        _this.selectRow.queryFireBook = resp;
        _this.selectRow.idStr = _this.idStr;
      };
      _this.http.get("/webapi/alarmSmoke/" + _this.alarmId, {}, success);
    },
    falseAlarm() {
      //设备误报
      let _this = this;
      _this.dialogVisible = true;

      let d = new Date()
      // str += d.getFullYear() + '年';
      // str += d.getMonth() + 1 + '月';
      // str += d.getDate() + '日';
      this.startTime += d.getHours() + ':'
      this.startTime += d.getMinutes()
      // str += d.getSeconds() + '秒';
      return this.startTime;
    },
    submitFalseContent() {
      let _this = this;
      if (_this.falseContent === "") {
        _this.$message.warning("请输入误报信息！");
        return;
      }
      var success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success("设备误报成功！");
          setTimeout(function () {
            _this.dialogVisible = false;
            _this.$emit("closeAlarmAuto");

            //清空
            _this.falseContent = "";
            _this.forbiddentime = '';
          }, 500);
        }
      };
      _this.http.post(
        "/webapi/writ/yesMisdeclaration",
        {content: _this.falseContent, id: _this.alarmId, forbiddentime: _this.forbiddentime},
        success
      );
    },
    changeSpan(index) {
      let arrIndex = this.spanIndex.indexOf(index);
      if (arrIndex > -1) {
        this.spanIndex.splice(arrIndex, 1);
      } else {
        this.spanIndex.push(index);
      }
    },
    callPhone(phone) {
      let _this = this;
      var success = function (resp) {
        if (!resp.code === "0") {
          _this.$message.warning("呼叫失败！");
        }
      };
      _this.http.post("/webapi/writ/voiceCalls", {phone: phone}, success);
    },
    dispatchOrder2() {
      let _this = this;
      if (_this.selectEquip && _this.selectCjPersons.length <= 0) {
        _this.$message.warning("请选择出警人员");
        return;
      }
      if (_this.selectEquip && _this.selectEqus.length <= 0) {
        _this.$message.warning("请选择装备");
        return;
      }
      _this.selectEqus.forEach(function (item) {
        if (item.num === 0) {
          _this.$message.warning("已选装备数量不能为0");

        }
      });
      var alarmCommanderIds = _this.selectCjPersons.map((item) => {
        return item.id;
      });
      var equipmentIds = _this.selectEqus.map((item) => {
        return item.id;
      });
      var equipmentNumbers = _this.selectEqus.map((item) => {
        return item.num;
      });
      var data = {
        id: _this.alarmId,
        alarmCommanderIds: alarmCommanderIds.join(),
        equipmentIds: equipmentIds.join(),
        equipmentNumbers: equipmentNumbers.join(),
      };
      var success = function (resp) {
        if (resp.code === "0") {
          _this.fireDocuDialog = true;
          // _this.$store.commit('updateSmokeAlarmActive',_this.active++);
          // _this.$store.commit('updateSelectFireBookActive','first');
        }
      };
      _this.http.post("/webapi/writ/goPoliceAdd", data, success);
    },

    dispathOrder() {
      let _this = this;
      _this.dispathOrderDialog = true;
      // _this.selectCjPersons=[];
      _this.$emit("closeAlarmAuto");
      setTimeout(()=>{
        _this.$refs.firePink.handleSearch();
      })
    },
    police() {
      let _this = this;
      _this.dispatchOrder2();
      _this.dispathOrderDialog = false;
    },
    //关闭调度派单页面
    closePathOrder(){
      let _this = this;
      _this.dispathOrderDialog = false;
    },
    //关闭火场文书弹框
    closeFireProbe() {
      let _this = this;
      console.log("关闭窗口")
      _this.fireDocuDialog = false;
    },
  },
};
</script>
<style lang="less">

.endNoticeDialog{
  .el-dialog__header{
    padding:25px;
    .el-dialog__headerbtn .el-icon-close{
      color:#fff
    }
  }
}
.dispathOrderBox {
  .el-dialog {
    background: #ffffff;
    border-radius: 18px;
  }

  .el-dialog__header {
    background: #0080DB;
    // display: none;
    border-radius: 18px 18px 0px 0px;
    .el-dialog__title {
      color: #fcfcfc;
    }
  }

  .el-dialog__body {
    padding: 20px;
  }

  .policeOut {
    text-align: center;
    margin-top: 13px;
  }
}

.fireDoc {
  .el-dialog {
    background: #ffffff;
    border-radius: 18px;
  }
}


.hand-footer-btn {
  text-align: center;

  .el-button {
    margin: 0px 10px;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.smoke-content {
  .hand-h1 {
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 25px;
    padding: 0px 0px 25px;
  }

  .hand-info {
    padding: 0px 20px 30px;

    .hand-text {
      background: #C8E8FF;
      padding: 20px;
      border-radius: 8px;

      p {
        padding: 10px 20px;
      }

      span {
        height: 18px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
      }

      i {
        color: #0080DB;
        margin: 0px 10px;
        font-size: 24px;
      }

      .el-button {
        margin-left: 10px
      }
    }
  }

  .hand-bot {
    margin-top: 20px;
    background: #C8E8FF;
    padding: 20px;
    border-radius: 8px;

    .hand-bot-text {
      margin: 10px 0px;
      font-size: 18px;

      i.el-icon-s-custom {
        font-size: 18px;
        margin: 0px 10px;
        color: #0080DB;
      }
    }
  }

  .el-form-item__label {
    color: rgb(0, 0, 0);
  }


  .el-form-item {
    margin-bottom: 0;
  }
}

.policeInfoTop {
  .el-tabs__active-bar {
    height: 7px;
    background: #ebeb6c;
    border-radius: 4px;
    // margin-left:78px;
  }

  .el-tabs__item {
    // padding:0 50px;
  }

  .el-tabs__nav {
    // padding-left: 78px;
    line-height: 64px;
    height: 64px;
  }
}

.fireText {
  color: #fff;
  text-align: left;
  font-size: 16px;

  .el-timeline-item {
    margin-bottom: 0;
  }

  .el-timeline-item__timestamp.is-top {
    margin: 0;
    padding: 0;
  }

  .msgFire {
    margin: 0 20px 0 50px;
  }
}
</style>
<style lang="less" scoped>
.smokeAlarmAuto {
  .policeInfo {
    width: 842px;
    margin: 18px auto;
    border: 1px solid #ffffff;
    border-radius: 10px;

    .policeInfoTop {
      text-align: center;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #fff;
      position: relative;

      .policeNum {
        text-align: right;
      }

      .policeText {
        text-align: left;
      }

      .police {
        height: 280px;
        overflow-y: scroll;
      }
    }

    .lineHei {
      line-height: 32px;
      font-size: 20px;
      color: #fff;
    }

    .policeInfoBot {
      padding: 10px 0 10px 43px;

      .el-form-item {
        margin: 0;
      }

      .piBot {
        span {
          line-height: 46px;
        }

        .piTopText {
          margin: 0 30px 0 0px;
          color: #fff;
          font-size: 16px;
        }
      }

      .piTopImg {
        vertical-align: middle;
      }

      .piBtn {
        width: 132px;
        height: 39px;
        border: 1px solid #ffffff;
        border-radius: 20px;
        background: #3b3b3b;
        color: #fff;
        margin-bottom: 6px;
        margin-right: 23px;
      }

      .el-input {
        width: 156px;
        height: 32px;
        border-radius: 10px;
      }

      .el-textarea__inner {
        border-radius: 10px;
      }
    }
  }

  .policeSub {
    text-align: center;
    margin-top: 20px;
  }
}

.warter_headerClose_color{
  .el-dialog {
    .el-dialog__header {
      .dialog__headerbtn .el-icon-close{
        color:#fff !important;
        font-size:20px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/alarm/smokeAlarmAuto.vue